import { NgModule } from '@angular/core';
import { HelpTargetDirective } from './directives/help-target.directive';
import { HelpDrawerComponent } from './help-drawer/help-drawer.component';
import { HelpWalkthroughOverlayComponent } from './help-walkthrough-overlay/help-walkthrough-overlay.component';

/**
 * Leads-scoped Help UI: drawer, help guide overlay, and {@link HelpTargetDirective}.
 */
@NgModule({
  imports: [HelpDrawerComponent, HelpWalkthroughOverlayComponent, HelpTargetDirective],
  exports: [HelpDrawerComponent, HelpWalkthroughOverlayComponent, HelpTargetDirective],
})
export class HelpLeadsUiModule {}
